import { FormErrors } from 'redux-form';
import { IPaymentForm } from '../store/Emit';

const validation = (values: IPaymentForm) => {
  const errors: FormErrors<any> = {};
  const reCreditCard = new RegExp(/^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12})$/)
  console.log(values.paymentMethod);
  if (values.paymentMethod === 'CMR') {
    if (!values.cmrCard) {
      errors.cmrCard = 'Debe ingresar el número de tarjeta';
    } else if (values.cmrCard.trim().length < 19) {
      errors.cmrCard = 'Debe ingresar los 16 dígitos de la tarjeta';
    }

    if (!values.declarationCard) {
      errors.declarationCard =
        'Debe aceptar los términos y condiciones. También debe confirmar que usted es el asegurado y pagador';
    }
  }

  if (values.paymentMethod === 'OTHERS') {
    if (!values.webpayCard) {
      errors.webpayCard = 'Debe ingresar el número de tarjeta';
    } else if (values.webpayCard.trim().length < 19) {
      errors.webpayCard = 'Debe ingresar los 16 dígitos de la tarjeta';
    } else if (!reCreditCard.test(values.webpayCard.trim().replace(/\s/g, ''))) {
      errors.webpayCard = 'Debe ingresar un número de tarjeta válido';
    }

    if (!values.webpayCardMonth) {
      errors.webpayCardMonth = 'Debe ingresar mes de expiración de tarjeta';
    }

    if (!values.webpayCardYear) {
      errors.webpayCardYear = 'Debe ingresar año de expiración de tarjeta';
    }

    if (!values.declarationCard) {
      errors.declarationCard =
        'Debe aceptar los términos y condiciones. También debe confirmar que usted es el asegurado y pagador';
    }
  }

  if (values.paymentMethod === 'MANDATE') {
    if (!values.nameBank) {
      errors.nameBank = 'Debe seleccionar un banco';
    }

    if (!values.accountBank) {
      errors.accountBank = 'Debe ingresar un número de cuenta corriente';
    } else if (
      values.accountBank.trim().length < 6 ||
      values.accountBank.trim().length > 16
    ) {
      errors.accountBank =
        'El número de cuenta corriente debe ser entre 6 y 16 caracteres';
    }

    if (!values.billingDay) {
      errors.billingDay = 'Debe ingresar un día de cobro';
    }
  }

  return errors;
};

export default validation;
